import { Card, CardBody, Col, Input } from "reactstrap";
import { ClipboardOnTextAreas, Copy, Cut, CutCopyFromTextarea } from "../../../../../utils/Constant";
import { Btn, P } from "../../../../../AbstractElements";
import { useState } from "react";
import CardHeaderCommon from "../../../../../CommonElements/CardHeaderCommon/CardHeaderCommon";
import { toast } from "react-toastify";

const ClipboardOnTextarea = () => {
  const clipBoardTextParagraph: string = "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business.";
  const [clipBoardValues, setClipBoardValues] = useState(clipBoardTextParagraph);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(clipBoardValues);
      setClipBoardValues( clipBoardValues);
    } catch (err) {
      toast.error("Failed to copy text: "+ err);
    }
  };

  const handleCut = async () => {
    try {
      await navigator.clipboard.writeText(clipBoardValues);
      setClipBoardValues("");
    } catch (err) {
      toast.error("Failed to cut text: "+ err);
    }
  };
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon title={ClipboardOnTextAreas} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="f-16">{CutCopyFromTextarea}</P>
            <Input className="f-14" type="textarea" rows={3} spellCheck="false" value={clipBoardValues} onChange={({ target: { value } }) => setClipBoardValues(value)} />
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard me-2" color="warning" onClick={handleCopy}>
                <i className="fa fa-copy"></i>
                {Copy}
              </Btn>
              <Btn className="btn-clipboard-cut" color="success" onClick={handleCut}>
                <i className="fa fa-cut"></i>
                {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ClipboardOnTextarea;
